import { cloudFunction } from 'services/parse';

export const createMedia = async (media: any) => {
  const response = await cloudFunction('createMedia', media);
  return response;
};

export const deleteMedia = async (id: string) => {
  const response = await cloudFunction('deleteMedia', { id });
  return response;
};

export const fetchPaginatedMedia = async (page: number, limit: number) => {
  const response = await cloudFunction('fetchPaginatedMedia', { page, limit });
  return response;
};

export const updateMedia = async (media: any) => {
  const response = await cloudFunction('updateMedia', media);
  return response;
};
